import React, { useState } from 'react'
import { Button, Typography } from '@mui/material';
import { Modal } from 'react-bootstrap'
import UpdateForm from './UpdateForm'

export default function RateID() {

  const [lgShow, setLgShow] = useState(false);


  return (
    <>

      <div className="row my-3 ">
        <div className="col-md-6">
          <Typography className="mx-3" variant='h4' sx={{ pb: 3 }}>
            Rate ID
          </Typography>
        </div>
        <div className="col-md-6 d-flex justify-content-end"   >

          <button type="button" className="btn btn-danger" onClick={() => setLgShow(true)} style={{ height: "40px" }}  >Help</button>
          <Modal
            size="lg"
            show={lgShow}
            onHide={() => setLgShow(false)}
            aria-labelledby="example-modal-sizes-title-lg"

          >
            <Modal.Header closeButton style={{ color: '#FFFFFF', backgroundColor: '#C62828' }}>
              <Modal.Title id="example-modal-sizes-title-lg" >
                Instructions to Add/Edit Rate ID
              </Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <h5>Create New Rate ID</h5>
              <ol>
                <li>Select Account Name from the dropdown
                </li>
                <li>Select Rate Code from the dropdown
                </li>
                <li>Note: Once you select the location name and rate code from the drop down you will see selected rate code along with locations for that particular account you selcted above
                </li>
                <li>Update the Rate ID feild for the rate code and location. (Rate ID can be Alphanumeric or Numbers)
                </li>
                <li>Click on save Button
                </li>
              </ol>

              <h5>Existing Rate ID:
              </h5>
              <ul>
                <li>To view/Edit Select the Account Name and rate code from the dropdown.</li>
              </ul>

            </Modal.Body>
          </Modal>

        </div>
      </div>


      {/* <div className="col-4 d-flex justify-content-end px-5">
        
          
         
        </div> */}




      <UpdateForm />





    </>
  );
}
